import type { ReactElement } from 'react';

import type { SectionItem as TSectionItem } from '../../../../components/text-page-item-section';
import TextPageSectionItem from '../../../../components/text-page-item-section';
import type { TrackInfo } from '../../types';

type Props = {
  section: {
    items: TSectionItem[];
  };
  trackInfo: TrackInfo;
};

export default function Section({ section, trackInfo }: Props): ReactElement {
  return (
    <>
      {section.items.map((sectionItem) => {
        return <TextPageSectionItem key={sectionItem.id} item={sectionItem} trackInfo={trackInfo} />;
      })}
    </>
  );
}
